var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlockquoteButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 11C7 11.5523 6.55228 12 6 12H4C3.44772 12 3 11.5523 3 11V7.55814C3 6.93799 3.06202 6.35917 3.18605 5.82171C3.33075 5.26357 3.53747 4.77778 3.8062 4.36434C4.09561 3.9509 4.45736 3.62015 4.89147 3.37209C5.32558 3.12403 5.83204 3 6.41085 3V4.55039C6.05943 4.55039 5.77003 4.64341 5.54264 4.82946C5.31525 4.99483 5.1292 5.22222 4.9845 5.51163C4.83979 5.80103 4.73643 6.13178 4.67442 6.50388C4.63307 6.8553 4.6124 7.20672 4.6124 7.55814H6C6.55228 7.55814 7 8.00586 7 8.55814V11Z",
    fill: "#585858"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 11C13 11.5523 12.5523 12 12 12H10C9.44772 12 9 11.5523 9 11V7.55814C9 6.93799 9.06202 6.35917 9.18605 5.82171C9.33075 5.26357 9.53747 4.77778 9.8062 4.36434C10.0956 3.9509 10.4574 3.62015 10.8915 3.37209C11.3256 3.12403 11.832 3 12.4109 3V4.55039C12.0594 4.55039 11.77 4.64341 11.5426 4.82946C11.3152 4.99483 11.1292 5.22222 10.9845 5.51163C10.8398 5.80103 10.7364 6.13178 10.6744 6.50388C10.6331 6.8553 10.6124 7.20672 10.6124 7.55814H12C12.5523 7.55814 13 8.00586 13 8.55814V11Z",
    fill: "#585858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockquoteButton);
export default __webpack_public_path__ + "static/media/blockquoteButton.c2cca3a6012af149a40136c1a9dc32d3.svg";
export { ForwardRef as ReactComponent };